import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=5369818d&scoped=true"
import script from "./StatsTable.vue?vue&type=script&lang=ts"
export * from "./StatsTable.vue?vue&type=script&lang=ts"
import style0 from "./StatsTable.vue?vue&type=style&index=0&id=5369818d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369818d",
  null
  
)

export default component.exports